export const LanguageDataEn = {
  AssociationValue: "Associated Value",
  AssociationField: "Association Field",
  String: "String",
  Text: "Text",
  Integer: "Integer",
  Decimal: "Decimal",
  Boolean: "Boolean",
  Date: "Date",
  Time: "Time",
  DateTime: "Date Time",
  Binary: "Binary",
  UnifiedDataType: "UDT",
  None: "None",
  Association: "Association",
  Enum: "Enumeration",
  DynamicProp: "Dynamic Property",
  PublicHelp: "Public Help",
  SystemProcess: "System Process",
  CreatingTime: "Creating Time",
  SavingTime: "Saving Time",
  Geometry: "Geometry"
}
